import api from '../../utils/api';
import {
    GET_ALL_PROJECT_BASED_JOB,
    GET_SPECIFIC_PROJECT_BASED_JOB,
    UPDATE_SPECIFIC_PROJECT_BASED_JOB,
    CREATE_NEW_PROJECT_BASED_JOB,
    REMOVE_PROJECT_BASED_JOB,
    UPDATE_RESULT_PROJECT_BASED_JOB,
    UPDATE_STATUS_PROJECT_BASED_JOB,
    ASSIGN_PROJECT_BASED_JOB,
    GET_MAX_VALUE_PROJECT_BASED_JOB
} from './types';
import { NotificationManager } from 'react-notifications';

export const getAllData = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/project-based-job', { params: filter }).then(res => {
            dispatch({ type: GET_ALL_PROJECT_BASED_JOB, payload: res.data.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const createData = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/project-based-job', data).then(res => {
            dispatch({ type: CREATE_NEW_PROJECT_BASED_JOB, payload: res.data.data });
            NotificationManager.success("Thêm mới bản ghi thành công!");
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const getData = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get(`/project-based-job/${id}`).then(res => {
            dispatch({ type: GET_SPECIFIC_PROJECT_BASED_JOB, payload: res.data.data });
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const updateData = (id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put(`/project-based-job/${id}`, data).then(res => {
            dispatch({ type: UPDATE_SPECIFIC_PROJECT_BASED_JOB, payload: res.data.data });
            NotificationManager.success("Cập nhật bản ghi thành công!");
            resolve(res.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const updateResult = (id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put(`/project-based-job/update-result/${id}`, data).then(res => {
            dispatch({ type: UPDATE_RESULT_PROJECT_BASED_JOB, payload: res.data.data });
            NotificationManager.success("Cập nhật bản ghi thành công!");
            resolve(res.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const updateStatus = (id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put(`/project-based-job/update-status/${id}`, data).then(res => {
            dispatch({ type: UPDATE_STATUS_PROJECT_BASED_JOB, payload: res.data.data });
            NotificationManager.success("Cập nhật bản ghi thành công!");
            resolve(res.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const removeData = (ids) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.delete(`/project-based-job`, { data: { ids: ids } }).then(res => {
            dispatch({ type: REMOVE_PROJECT_BASED_JOB, payload: ids });
            NotificationManager.success("Xoá bản ghi thành công!");
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const assignData = (ids, data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post(`/project-based-job/assign`, { ids, data }).then(res => {
            dispatch({ type: ASSIGN_PROJECT_BASED_JOB, payload: res.data.data });
            NotificationManager.success(res.data.msg);
            resolve(res.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const getMaxValue = (column) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/project-based-job/get/max-value', { params: column }).then(res => {
            dispatch({ type: GET_MAX_VALUE_PROJECT_BASED_JOB, payload: res.data.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}